import { RootState } from "@src/store";
import { experienceBuilderSlice } from "@src/store/slices/experienceBuilder/slice";

const { getPluginConfigState } = experienceBuilderSlice.selectors;

export const getPluginConfigVersion = (state: RootState) => {
  const pluginConfigState = getPluginConfigState(state);
  if (pluginConfigState) {
    return pluginConfigState.version ?? null;
  } else {
    return undefined;
  }
};
